import React from "react";
import '../styles/Footer.css';

const Footer = () => (

    <div className="Creditos">
        <a href='https://www.skyzdesign.com.br'><h3>© 2025 - SkyZ Design</h3></a>
    </div>

);

export default Footer;